import React from 'react';
import SearchPart from './SearchPart';
import { useTranslation } from 'react-i18next';

const Hero = () => {
    const { t } = useTranslation()
    return (
        <div
            className=" xs:h-[80vh] sm:h-[70vh] relative bg-cover bg-center"
            style={{ backgroundImage: "url('/asset/login-bg.jpg')" }}
        >
            <div className="absolute inset-0 bg-black/50" />

            <div className="relative z-10 h-full flex-col flex-center text-center px-4">
                <h1 className="xs:text-3xl md:text-5xl  font-bold text-white mb-4 drop-shadow-lg">
                    {t("hero.title")}
                </h1>
                <p className="text-white text-lg mb-8">
                    {t("hero.subtitle")}
                </p>

                <div className="w-full ">
                    <SearchPart />
                </div>
            </div>
        </div>
    );
};

export default Hero;
